import styled from "styled-components";
import { dispositivo } from "../../components/Dispositivos";

export const AutocompleteWrapper = styled.div`
  background-color: rgb(12, 141, 227);
  padding: 20px;
  border-radius: 0px;
  width: 100%;
`;

export const AutocompleteStyle = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
`;

export const AutocompleteResultStyle = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 100;
  background-color: #ffffff;
  width: 100%;
  color: #0C234C;
  list-style-type: none;
  border-radius: 4px;
  font-size: 16px;
  box-shadow: 0px 4px 10px rgb(50 151 169 / 30%);
  padding: 0;
  margin: 5px 0 0 0;

  .liStyle {
    padding: 10px;
    cursor: pointer;
    &:hover {
      background: #67D2DC;
      color: #0C234C;
    }
  }
`;

export const FormField = styled.input`
  border-radius: 12px;
  margin: 0;
  width: 100%;
  border: 1px solid #67D2DC;
  outline: 0;
  font-size: 18px;
  color: #0C234C;
  padding: 10px;
  background: #ffffff;
  transition: border-color 0.2s;

  &::placeholder {
    color: #0C234C;
    opacity: 0.5;
  }
`;

export const AutocompleteSearch = styled.div`
  position: relative;
  width: 100%;
`;

export const IconsWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 15px;

  img {
    cursor: pointer;
    height: 30px;
    margin-left: 10px;
    transition: transform 0.2s;

    &:hover {
      transform: scale(1.1);
    }
  }
`;

export const PhoneInputPanel = styled.div`
  position: absolute;
  top: 110%;
  right: 0;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 16px;
  margin-top: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  max-width: 320px;
  z-index: 1000;
`;